<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="OutPocCostId"
      ref="list"
      unit="加工费用单"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="true"
      :queryParamsAppend="params"
      :get-data-func="api.list"
      @showRow="showRow"
      urlHash="finance/dealings/machiningcost"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="primary" @click="onExport" >导出</el-button>
      </template>
      <template slot="query">
        <el-form-item label="外协单位" label-width="100px">
          <select-input
            placeholder="请选择外协单位"
            :label="params.TradeUnitName"
            v-model="params.TradeUnitId"
            @click="openTradeunit"
          />
        </el-form-item>
        <el-form-item label="单据编码" label-width="100px">
          <el-input
            clearable
            v-model="params.DocNo"
            placeholder="请输入单据编码"
          />
        </el-form-item>

        <el-form-item label="单据日期"  label-width="100px">
          <range-picker
            :date="[params.DocDateStart, params.DocDateEnd]"
            @change="
              (x) => {
                params.DocDateStart = x.Start;
                params.DocDateEnd = x.End;
              }
            "
            style="min-width: 180px"
          />
        </el-form-item>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <el-table class="subItem-table" :data="subList" v-if="show" border>
      <el-table-column
        align="center"
        prop="WorkDocNo"
        label="工单编码"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="InNumber"
        label="入库编码"
      ></el-table-column>
      <el-table-column align="center" prop="ProductNo" label="产品编码"></el-table-column>
      <el-table-column align="center" prop="ProductName" label="产品名称"></el-table-column>
      <el-table-column align="center" prop="ProductSpec" label="产品规格"></el-table-column>
      <el-table-column align="center" prop="UnitName" label="产品单位"></el-table-column>
      <el-table-column align="center" prop="PropertyName" label="属性"></el-table-column>
      <el-table-column align="center" prop="ColorName" label="颜色"></el-table-column>
      <el-table-column align="center" prop="Quantity" label="数量"></el-table-column>
      <el-table-column align="center" prop="PocUnitPrice" label="加工单价" v-if="canPrice"></el-table-column>
      <el-table-column align="center" prop="PocAmount" label="加工金额" v-if="canPrice">
          <template slot-scope="{row}">
            {{row.PocAmount.toLocaleString()}}
          </template>
      </el-table-column>
    </el-table>
    <tradeunit-dialog
      ref="tradeunitDialog"
      in-dialog
      selectable
      @select="setTradeunit"
    />
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/finance/dealings/machiningcost/list.json";
import tableParam from "@/data/finance/dealings/machiningcost/query.json";
import tradeunitDialog from "@/components/basedata/business/come/listDialog";

export default {
  mixins: [listMixin],
  components: { list, tradeunitDialog },
  data() {
    return {
      api: require("@/api/rp/outPocCost").default,
      show: false,
      subList: [],
      params: {
        TradeUnitId: null,
        TradeUnitName: "",
        DocNo: "",
        DocDateStart: this.$commonJs.getToday(),
        DocDateEnd: this.$commonJs.getToday(),
      },
    };
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice("/finance/dealings/machiningcost");
    },
  },
  mounted() {
    if (!this.$permission.canPrice("/finance/dealings/machiningcost")) {
      const findIndex = this.$refs.list.tableList.findIndex(item => item.tableName == "Amount");
      if (findIndex >= 0) this.$refs.list.tableList.splice(findIndex, 1);
    }
  },
  methods: {
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var list = this.$refs.list;
          var listParams = list.tempQueryParams;
          var fields = list.tableList.map(x => x.tableName);
          var params = { ...listParams, Fields: fields.join(',') };
          // console.log('onExport', params);
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.export(params).then(res => {
            loading.close();
          })
        })
        .catch(() => {});
      
    },
    showRow(data) {
      // console.log('当前行');
      console.log(data);
      this.show = false;
      this.api.info(data.OutPocCostId).then(res=>{
          if(res.Code === 0 && res.Data.Products.length !== 0){
            this.show = true;
            this.subList = res.Data.Products
          }
      })
      
    },
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData({TradeUnitType:3});
      });
    },
    setTradeunit(data) {
      this.params.TradeUnitId = data.TradeUnitId;
      this.params.TradeUnitName = data.FullName;
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.subItem-table {
  margin-top: 30px;
}
</style>
